import { render, staticRenderFns } from "./CoinsIcon.vue?vue&type=template&id=7ad0d1fe"
import script from "./CoinsIcon.vue?vue&type=script&lang=js"
export * from "./CoinsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports